export const heroData = {
  title: "91官网 · 官方正版入口",
  subtitle: "安全认证 · 实名保障 · 稳定服务",
  description: "91官网是您访问91平台的唯一官方正版入口。本站提供最新地址导航、账号登录指引以及全面的安全验证服务，帮助您远离仿冒钓鱼网站，确保您的账户与个人信息安全无忧。",
  primaryButton: "立即访问官网",
  secondaryButton: "了解更多",
};

export const featuresData = [
  {
    id: 1,
    icon: "ri-shield-check-line",
    title: "官方认证",
    description: "经权威机构认证的正版平台入口，确保您访问的是真实可靠的91官方网站，杜绝虚假仿冒站点。",
  },
  {
    id: 2,
    icon: "ri-fingerprint-line",
    title: "实名保障",
    description: "采用多重身份验证机制，严格实行实名制管理，为每一位用户提供安全可靠的使用环境。",
  },
  {
    id: 3,
    icon: "ri-server-line",
    title: "稳定服务",
    description: "高性能服务器集群支撑，7×24小时不间断运行，确保平台访问快速稳定，体验流畅。",
  },
  {
    id: 4,
    icon: "ri-lock-password-line",
    title: "数据加密",
    description: "采用国际领先的SSL/TLS加密技术，全方位保护您的账户信息、交易数据和隐私安全。",
  },
  {
    id: 5,
    icon: "ri-customer-service-2-line",
    title: "专属客服",
    description: "专业客服团队全天候在线，快速响应您的各类咨询与问题，提供贴心周到的服务支持。",
  },
  {
    id: 6,
    icon: "ri-alert-line",
    title: "风险预警",
    description: "实时监测网络安全威胁，及时发布钓鱼网站警示信息，帮助用户有效识别和规避风险。",
  },
];

export const securityBadgesData = [
  { id: 1, icon: "ri-verified-badge-line", label: "SSL安全认证" },
  { id: 2, icon: "ri-shield-star-line", label: "实名制认证" },
  { id: 3, icon: "ri-auction-line", label: "合法合规运营" },
  { id: 4, icon: "ri-database-2-line", label: "数据安全防护" },
];

export const statsData = [
  { id: 1, value: "1000万+", label: "累计服务用户" },
  { id: 2, value: "99.99%", label: "服务可用率" },
  { id: 3, value: "8年+", label: "稳定运营时间" },
  { id: 4, value: "7×24h", label: "全天候监控" },
];

export const faqData = [
  {
    id: 1,
    question: "如何确认访问的是91官网正版入口？",
    answer: "您可以通过检查浏览器地址栏中的网址是否正确，以及页面是否显示官方安全认证标识来确认。正版91官网使用HTTPS加密连接，地址栏会显示安全锁图标。建议将官网地址加入浏览器收藏夹，避免通过搜索引擎点击不明链接。",
  },
  {
    id: 2,
    question: "91官网登录遇到问题怎么办？",
    answer: `如果登录遇到困难，请先检查网络连接是否正常，确认输入的账号密码是否准确。如忘记密码，可点击登录页面的"找回密码"功能进行重置。若问题仍未解决，请联系官方客服获取进一步帮助。`,
  },
  {
    id: 3,
    question: "如何辨别仿冒钓鱼网站？",
    answer: "仿冒网站通常存在以下特征：网址拼写与官方有细微差异、页面设计粗糙、频繁弹出广告窗口、要求提供超出正常范围的个人信息等。请始终通过官方渠道访问，不要轻信短信或邮件中的链接。",
  },
  {
    id: 4,
    question: "91官网的最新地址在哪里获取？",
    answer: "91官网的最新地址请以本网站公布的信息为准。建议您关注官方公告渠道，或直接收藏本页面（91guanwang.com），以便第一时间获取最新、最准确的官方入口信息。",
  },
  {
    id: 5,
    question: "账户安全如何保障？",
    answer: "平台采用多重安全防护措施：实名认证机制确保用户身份真实有效，SSL加密技术保护数据传输安全，智能风控系统实时监测异常操作，定期安全检查排除隐患。同时建议用户开启双重验证，进一步增强账户安全性。",
  },
  {
    id: 6,
    question: "遇到可疑情况应该如何处理？",
    answer: "如发现可疑网站或收到可疑信息，请立即停止操作，不要输入任何个人信息。您可以通过官方客服渠道进行举报和核实。同时建议截图保存证据，以便后续追溯和处理。",
  },
];

export const ctaData = {
  title: "立即访问91官方正版平台",
  description: "选择正规渠道，保障您的账户与信息安全。收藏本页面，随时获取最新官方入口。",
  buttonText: "进入91官网",
};